import { render, staticRenderFns } from "./SidebarButton.vue?vue&type=template&id=65de43c5&scoped=true&"
import script from "./SidebarButton.vue?vue&type=script&lang=js&"
export * from "./SidebarButton.vue?vue&type=script&lang=js&"
import style0 from "./SidebarButton.vue?vue&type=style&index=0&id=65de43c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65de43c5",
  null
  
)

export default component.exports